import type { MortgageRateResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type Args = {
	ltv: number;
	amount: number;
	years: number;
};

export const matchesMortgageRate = (
	row: MortgageRateResponseDTO,
	{ ltv, amount, years }: Args,
) =>
	ltv >= row.ltvFrom &&
	ltv <= row.ltvTo &&
	amount >= row.amountFrom &&
	amount <= (row.amountTo ?? Number.POSITIVE_INFINITY) &&
	years >= row.maturityFrom &&
	years <= row.maturityTo;
